import React, { Component} from 'react';
import imgCaptn from '../../../../images/HairyBeastRun.gif'
import imgN3RD from '../../../../images/RedHeadRun.gif'
import imgSniper from '../../../../images/SpaceAgentRun.gif'
import imgDr from '../../../../images/PurpleAlienRun.gif'
// import API from'../utilities/API'
// import {  NavLink, Redirect  } from 'react-router-dom'

class vcEnemyCard extends Component {
  
  constructor(props) {
    
    super(props);
    this.CAPSkills = ['Pass','1 Liner','Massive-Attack','Tooty-Booty','Charge'];
    this.N3RDSkills = ['Pass','Hack', 'Nano Wall', 'Nano Slice','Mega Laser'];
    this.SniperSkills = ['Pass','Hand Cannon', 'Head Shot', 'Cloak', 'Electric Smoke'];
    this.DoctorSkills =['Pass', 'Heal','Poison Dart','Poison Grenade', 'Ressurect'];
    this.enemyname = this.funnyname();
    switch(this.props.char){
        case 'CAP':
          this.charpic = imgCaptn;
          this.charActions = this.CAPSkills;
          break;
        case 'N3RD':
          this.charpic = imgN3RD;
          this.charActions = this.N3RDSkills;
          break;
        case 'SNIPE':
          this.charpic = imgSniper;
          this.charActions = this.SniperSkills;
          break;
        case 'DOC':
          this.charpic = imgDr;
          this.charActions = this.DoctorSkills;
          break;
        default:
          this.charpic = imgCaptn;
          this.charActions =  this.CAPSkills;
          break;
   
        }
    this.state = {
      eName: this.enemyname,
      char: this.props.char,
      action: 'Pass',
      target: 'None',
      charActions: this.charActions,
      setChar: this.props.setChar,
    }
    this.props.setChar({name:this.enemyname,type:this.state.char});
    
  }
componentDidMount(){
this.dd = [];
this.dd.length=0;
this.dd = this.state.charActions.map((X)=>(<div onClick={this.handleActionEvent}  className="dropdown-item" value={X}>{X}</div>))

this.tgt = ['none','bad1','bad2','bad3','bad4'];
this.enemies = this.tgt.map((X)=>(<div onClick={this.handleTargetEvent} className="dropdown-item" value={X}>{X}</div>))

}  

funnyname(){
  this.title = ['Doc ','Grand ','Dire ','Madam ', 'MixMaster ', 'Sir ', 'Miss ', 'Senore ','Father ', 'Rev. ', 'The', 'Captain','Sargent ','Keiser ','Lady ', 'President ']
  this.first = ['Janet ','Liz ','Chang ', 'Vertch ', 'Mike ', 'Rob ', 'Lugthar ','Froje ','Bananna ','Sue ','Luvitch ','Bob ', 'Tuna ', 'Kee', 'Nerf ', 'Vun ','XXXXsssssyy ', 'Strange ','jr ']
  this.last = ['X ','Bukbuk ','FruitSalad ','Twinky ','Narharnelharg ','Smith ','Knucklebustien ', 'Vez ', 'Vornador ','MongMong ','Trex ']
  this.honhorrific = ['The Great','The Uncomfortable','the underwhelmed','THE OVERBEARING','party d.j.','the un-unamed','the deadly','the silent','the deadly and silent','the silent and deadly','the really nice','the mediocre','the good with numbers', 'the fun at parties']
   
  let out = "";
  if(Math.random()>.7){
    out += this.title[Math.floor(Math.random()*this.title.length)];
  }
  if(Math.random()<.8){
    out += this.first[Math.floor(Math.random()*this.first.length)];
  }
  out += this.last[Math.floor(Math.random()*this.last.length)];
  if(Math.random()>.7){
    out += this.honhorrific[Math.floor(Math.random()*this.honhorrific.length)];
  }
  return (out);
}
handleTouch = (e) => {
  e.preventDefault();  //let sty = {backgroundColor:'green'}
  //this.setState({stylcharcontrol:sty});  
  //this.setState({target: e.target.getAttribute("value")});
  
  this.props.setChar({ type:this.state.char, name:this.state.eName});
  
  this.setState({type: e.target.getAttribute("value")});
  

}
// handleActionEvent = (e) => {
//   e.preventDefault()

//   // if (e.target.getAttribute("myType")==="Act"){});}
//   console.log("in act");
//   this.setState({action: e.target.getAttribute("value")});  

// }

// handleTargetEvent = (e) => {
//   console.log("in targ");
//   e.preventDefault()
//   this.setState({target: e.target.getAttribute("value")});
//   // if (e.target.getAttribute("myType")==="Act"){});}
//   //console.log("in here");
//   //this.setState({action: e.target.getAttribute("value")});  

// }

   
    render() {

      
      
      const pgImg ={ width:'6rem', height:'8rem', float:"left"}
      const stylcommands={'font-size': '2em'}
      //const stylcharcontrol={'background': 'linear-gradient(to bottom right, darkgrey, black)', 'border-radius':'0 25px 0 25px'}
      let stylcharcontrol = {'background': 'linear-gradient(to bottom right, darkgrey, black)', 'borderRadius':'0 25px 0 25px'}; 
            

      if(this.state.eName===this.props.getSelChar()){
        stylcharcontrol = {'background':'linear-gradient(to bottom right, purple, black)', 'borderRadius':'0 25px 0 25px'}
      }
      
      return (
        
        <div onClick={this.handleTouch} style={stylcharcontrol}>        

          <img className="img-thumbnail img-responsive mr-3" style={pgImg} src={this.charpic} alt="character"/>
         
          <div style={stylcommands} className="dropdown">
            <div>
              <h6>Name: {this.enemyname}</h6>
            <div>
              
              Hit Points:
              </div>
              <div>
              Buffs:
              </div>
              <div>
              Nerfs:
              </div>
            </div>
            <div className="dropdown">Action:
              
                {this.state.action}

            </div>
            <div className="dropdown">Target:

            </div>
            
        </div>    
        </div>    
  
           );            
              
  
      
    }  

  
}




export default vcEnemyCard; 


// WEBPACK FOOTER //
// ./src/components/Games/VoidCheddar/Parts/vcEnemyCard.js